import { GetDevicesResponse } from '@eppendorf/vnls-device-service-utils';
import { QueryClient } from '@tanstack/react-query';
import { Outlet, useRouteError } from 'react-router-dom';

import { prepopulateCache } from '$shared/utils/react-query.utils';

import { DeviceList } from '$features/device-list';
import { createDevicesV2QueryWithQueryParams } from '$features/monitoring/v2/devicesv2.api';

export async function devicesLoader(queryClient: QueryClient): Promise<null> {
  return prepopulateCache<GetDevicesResponse>(
    queryClient,
    createDevicesV2QueryWithQueryParams({
      page: 1,
      pageSize: 10,
      searchQuery: '',
    }),
  );
}

export function DevicesPage() {
  const routeError = useRouteError();
  return (
    <>
      <DeviceList />

      {!routeError && <Outlet />}
    </>
  );
}
